module.exports = __webpack_public_path__ + "static/media/agnus-dei-original-p1.7449e770.jpg";